import { AreaItem } from '@/types/cms/AreaItem'
import AppContext from '@/types/context'
import Gallery from '@/elements/widgets/Gallery/Gallery'
import styles from '@/elements/widgets/Gallery/GalleryDefault.module.scss'
import ShareBtn from '@/components/ShareBtn/ShareBtn'
import React from 'react'

const GalleryDefault = ({ item, context }: { item: AreaItem; context: AppContext }) => {
  const gallery = item.items?.find((child) => child.type === 'gallery')
  if (!item?.items || !gallery) {
    return
  }

  const current = new Date(gallery.model.publishedAt)
  const date = current.toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
  const dateTime = current.toLocaleString('de-DE', {
    hour: '2-digit',
    minute: '2-digit',
  })

  return (
    <div className={styles.container}>
      <Gallery context={context} item={item} />
      <div className={styles['caption-container']}>
        <div className={styles['share-btn']}>
          <ShareBtn url={globalThis?.window?.location?.href} withText />
        </div>
        <span className={styles.date}>
          {date} | {dateTime} Uhr
        </span>
        <h2 className={styles.headline}>{gallery.model.headline}</h2>
        <span className={styles['lead-text']}>{gallery.model.leadtext}</span>
      </div>
    </div>
  )
}

export default GalleryDefault
